import { BaseDto } from "@/shared/dtos/base-dto";

export class pantalla_lista extends BaseDto {
  public nombre!: string;
  public anyadir!: boolean;
  public editar!: boolean;
  public borrar!: boolean;
  public api_call!:string;
}
